import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-student-photos',
  templateUrl: './student-photos.component.html',
  styleUrls: ['./student-photos.component.sass']
})
export class StudentPhotosComponent implements OnInit {

  public isLoading: boolean;

  students: any;
  email: string;
  password3: string;
  confirmPassword: string;
  studentsListSubs: Subscription;
  studentsList: Student[];
  schoolsListSubs: Subscription;
  schools: any;
  stagesListSubs: Subscription;
  stages: any;
  gradesListSubs: Subscription;
  grades: any;
  // linesListSubs: Subscription;
  // lines: any;
  params: Student[];
  isList: boolean = true;
  isNew: boolean = true;
  private routeSub: Subscription;
  type_accept: string;
  studentForm: FormGroup;
  filterForm: FormGroup;
  pageEvent: PageEvent;
  modification_date: string;
  creation_date: string;
  readOnly: boolean = false;
  pageSize: number = 100;
  pageIndex: number = 0;
  totalItems: any;
  selectedFiles: File;
  selectedSecondaryFiles: File;
  student_photo: any;
  displayedColumns: string[] = ['name', 'school', 'stage', 'grade', 'num_list', 'actions'];
  dataSource: Student = null;
  disableClearFilterButton: boolean = true;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showStudentPhotosProgressBar: boolean = false;
  showStudentPhotosProgressBar2: boolean = false;


  constructor(
    public dataService: DataService,
    private http: HttpClient,
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar
  ) { }

  public getStudentphotos() {

    this.studentsListSubs = this.dataService
      .getStudentphotos('')
      .subscribe(res => {
        this.students = res;
      },
        console.error
      );
  }

  public getSchools() {

    // Retrieve school filter from local storage.
    let schoolFilter = localStorage.getItem("school_filter");

    var params = {};
    params['page'] = 1
    params['size'] = 100000
    params['search'] = ''
    this.schoolsListSubs = this.dataService
      .getSchools(params)
      .subscribe(res => {
        this.schools = res['items'];
        // this.schools = [{ 'id': null, 'name': "" }].concat(this.schools)

        if (schoolFilter && schoolFilter != "null") {
          let callTableUpdates = true;
          // We loop through schools to make sure our filter matches existing school.
          res['items'].forEach(school => {
            // We update only if our filter matches an existing school ID, otherwise no filter is applied.
            if (school.id == schoolFilter) {
              this.filterForm.controls["schools"].setValue(schoolFilter);
              callTableUpdates = false
              this.getStages(schoolFilter, false);
            }
          });

          if (callTableUpdates) {
            var params = {};
            params['page'] = 1
            params['size'] = this.pageSize
            params['search'] = '';
            params['role'] = '';
            this.updateStudentsTable(params);
            this.updatePaginator(params);
          }


        } else {
          this.dataSource = <any>[];

        }
        this.isLoading = false

        // this.studentForm.controls["schools"].setValue(res['items'][0]['id'])
        // this.getStages(res['items'][0]['id'])
      },
        console.error
      );
  }

  public getStages(schoolID: string, updateFilters: boolean = true) {

    // When this function is called, a school filter has been selected/applied
    // We save this filter to local Storage
    if (updateFilters) {
      localStorage.setItem("school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("stage_filter", "");
      localStorage.setItem("grade_filter", "");
    }

    let stageFilter = localStorage.getItem("stage_filter");


    // this.stages = [{ 'id': null, 'name': "" }]
    // this.grades = [{ 'id': null, 'name': "" }]
    this.stages = []
    this.grades = []
    this.studentForm.controls["stages"].setValue('')
    this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')
    this.filterForm.controls["stages"].setValue('')
    this.filterForm.controls["grades"].setValue('')
    // this.filterForm.controls["lines"].setValue('')
    if (!stageFilter || schoolID == null) {
      this.applyFilter(null)
      if(schoolID == null){
        return true
      }
    }


    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        this.stages = res;

        if (stageFilter) {

          let callTableUpdates = true

          this.stages.forEach(stage => {

            if (stageFilter == stage.id) {

              this.filterForm.controls["stages"].setValue(stageFilter);
              callTableUpdates = false
              this.getGrades(stageFilter, false);

            }

          });

          if (callTableUpdates) {
            this.applyFilter(null);
          }

        }

        this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
        // this.studentForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])



      },
        console.error
      );
  }

  public getGrades(stageID: string, updateFilters: boolean = true) {

    if (updateFilters) {
      localStorage.setItem("school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("stage_filter", this.filterForm.controls["stages"].value);
      localStorage.setItem("grade_filter", "");

    }

    let gradeFilter = localStorage.getItem("grade_filter");

    // this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')
    this.filterForm.controls["grades"].setValue('')
    // this.filterForm.controls["lines"].setValue('')
    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID
    if (!gradeFilter) {
      this.applyFilter(null)
    }

    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;

        if (gradeFilter) {

          let callTableUpdates = true

          this.grades.forEach(grades => {
            if (gradeFilter == grades.id) {
              this.filterForm.controls["grades"].setValue(gradeFilter);
              callTableUpdates = false;
              this.applyFilter(null, gradeFilter);
            }
          });

          if (callTableUpdates) {
            this.applyFilter(null);
          }

        }

        this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        // this.studentForm.controls["grades"].setValue(res[0]['id'])
        // this.getLines(res[0]['id'])
      },
        console.error
      );
  }

  public updatePaginator(params) {
    this.dataService.getTotalStudents(params).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe()
  }

  public updateStudentsTable(params) {
    this.dataSource = null;
    this.filterForm.disable();
    this.dataService.getStudentphotos(params).pipe(
      map((tableData: Student) => this.dataSource = tableData)
    ).subscribe(() => {this.showStudentPhotosProgressBar = false; this.filterForm.enable();})
  }

  public clearFilterButtonState() {

    if (
      this.filterForm.controls["schools"].value != '' ||
      this.filterForm.controls["stages"].value != '' ||
      this.filterForm.controls["grades"].value != ''
    ) {
      this.disableClearFilterButton = false;
    } else {
      this.disableClearFilterButton = true;
    }

  }

  // public getLines(gradeID: string) {
  //   this.studentForm.controls["lines"].setValue('')
  //   this.filterForm.controls["lines"].setValue('')
  //   var params = {}
  //   params['school_id'] = ''
  //   params['grade_id'] = gradeID
  //   this.linesListSubs = this.dataService
  //     .getLines(params)
  //     .subscribe(res => {
  //       this.lines = res;
  //       this.lines = [{'id':null, 'name':""}].concat(this.lines)
  //       this.studentForm.controls["lines"].setValue(res[0]['id'])

  //       },
  //       console.error
  //     );
  // }


  // ngAfterViewInit() {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }


  ngOnInit() {
    this.type_accept = '.jpeg, .png, .jpg';
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      next_student_id: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      schools: new FormControl('', Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
      // lines: new FormControl('', Validators.required),
      num_list: new FormControl('', Validators.required),
    });
    this.filterForm = this.formBuilder.group({
      schools: new FormControl(null),
      stages: new FormControl(null),
      grades: new FormControl(null),
      // lines: new FormControl(null),
    });

    this.isLoading = true;
    this.getSchools();

    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = '';
    params['role'] = '';

    if(localStorage.getItem('student-photos'))
    {
      let data = JSON.parse(localStorage.getItem('student-photos'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1
      params['size'] = this.pageSize

      if(data.search)
      {
        params['search'] = data.search
      }
      if(data.school_id)
      {
        params['school_id'] = data.school_id
      }
      if(data.stage_id)
      {
        params['stage_id'] = data.stage_id
      }
      if(data.grade_id)
      {
        params['grade_id'] = data.grade_id
      }
    }

    // if (!localStorage.getItem('school_filter')) {
    //   this.updateStudentsTable(params)
    //   this.updatePaginator(params);
    // }

    this.routeSub = this.route.params.subscribe(params => {
      if (params.id) {
        this.isList = false;

        if (params.id != 'new') {
          this.showStudentPhotosProgressBar2 = true;
          this.isNew = false;
          this.studentsListSubs = this.dataService
            .getStudentphoto(params.id)
            .subscribe(res => {
              this.students = res;
              this.studentForm.controls["id"].setValue(this.students['id']);
              this.studentForm.controls["name"].setValue(this.students['name']);
              this.studentForm.controls["next_student_id"].setValue(this.students['next_student_id']);

              this.studentForm.controls["schools"].setValue(this.students.school._flat_path[1].toString());
              this.getStages(this.students.school._flat_path[1].toString(), false)
              this.getGrades(this.students.stage._flat_path[1].toString(), false)
              this.studentForm.controls["stages"].setValue(this.students.stage._flat_path[1].toString());
              this.studentForm.controls["grades"].setValue(this.students.grade._flat_path[1].toString());
              // this.studentForm.controls["lines"].setValue(this.students.line._flat_path[1].toString());
              this.studentForm.controls["num_list"].setValue(this.students['num_list']);
              this.student_photo = [{ "imageUrl": this.students['primary_photo'], "imageUrl2": this.students['secondary_photo'] }]
              // const storageRef = this.firebaseStorageService.referenciaCloudStorage(this.students['primary_photo']);
              // storageRef.getDownloadURL().subscribe(downloadURL => {
              //   this.student_photo = [{"imageUrl":downloadURL}]
              // });
              this.creation_date = this.students.creation_date;
              this.modification_date = this.students.modification_date;
              //           this.studentsList = res;


              this.showStudentPhotosProgressBar2 = false
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
      }
      else {
        this.isList = true;
        if(params.search || params.stage_id || params.grade_id || params.school_id)
        {
          //this.applyFilter(null, true)
        }
      }

      
      //this.codeId = params['id'];
    });
  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    else {
      this.selectedSecondaryFiles = event.target.files;
    }

  }


  goTo(studentID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    data['search'] = <HTMLInputElement>document.getElementById("input") == null ? null : (<HTMLInputElement>document.getElementById("input")).value;
    data['school_id'] = this.filterForm.controls["schools"].value
    data['stage_id'] = this.filterForm.controls["stages"].value
    data['grade_id'] = this.filterForm.controls["grades"].value

    localStorage.setItem('student-photos', JSON.stringify(data))
    this.router.navigateByUrl(`studentphoto/${studentID}`);

  }


  deletePhoto(type: String) {
    this.routeSub = this.route.params.subscribe(data => {
      let params = {}
      params['id_student'] = data.id
      params['type'] = type
      this.dataService.deletePhoto(params).subscribe(res => {
        if (res == 'ok') {
          this.translate.get('alerts.photo_deleted').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
          })
          return false;
        }
        else {
          this.translate.get('alerts.delete_photo_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }


  applyFilter(event: Event, gradeID: any = false) {
    // Auto enables after updateStudentsTable() gets API call response.
    this.filterForm.disable();

    if (event || gradeID) {
      localStorage.setItem("school_filter", this.filterForm.controls["schools"].value);
      localStorage.setItem("stage_filter", this.filterForm.controls["stages"].value);
      localStorage.setItem("grade_filter", this.filterForm.controls["grades"].value);
    }

    this.showStudentPhotosProgressBar = true;
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['school_id'] = this.filterForm.controls["schools"].value;
    params['stage_id'] = this.filterForm.controls["stages"].value;
    params['grade_id'] = this.filterForm.controls["grades"].value;
    // params['line_id'] = this.filterForm.controls["lines"].value;


    // TODO Review issue fix where period and grade weren't showing (ERROR TypeError: Cannot read property 'value' of null)
    params['search'] = <HTMLInputElement>document.getElementById("input") == null ? null : (<HTMLInputElement>document.getElementById("input")).value;


    
    // this.dataService.getStudentphotos(params).pipe(
    //   map((tableData: Student) => this.dataSource = tableData)
    // ).subscribe(() => this.showStudentPhotosProgressBar = false)

    this.updateStudentsTable(params)

    // this.dataService.getTotalStudents(params).pipe(
    //   map((totalItems) => this.totalItems = totalItems)
    // ).subscribe()

    this.updatePaginator(params);

    this.clearFilterButtonState();

  }

  clearFilters() {

    localStorage.removeItem("school_filter");
    localStorage.removeItem("stage_filter");
    localStorage.removeItem("grade_filter");

    this.filterForm.controls["schools"].setValue('')
    this.filterForm.controls["stages"].setValue('')
    this.filterForm.controls["grades"].setValue('')

    this.stages = []
    this.grades = []

    // this.applyFilter(null)
    this.dataSource = <any>[]


  }

  newStudent() {
    this.router.navigateByUrl(`studentphoto/new`);
  }

  saveStudentphoto() {
    var params = {};
    params['id'] = this.studentForm.controls["id"].value;
    params['name'] = this.studentForm.controls["name"].value;
    params['school_id'] = this.studentForm.controls["schools"].value;
    params['stage_id'] = this.studentForm.controls["stages"].value;
    params['grade_id'] = this.studentForm.controls["grades"].value;
    // params['line_id'] = this.studentForm.controls["lines"].value;
    params['num_list'] = this.studentForm.controls["num_list"].value;

    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if (params['school_id'] == '') {
      this.translate.get('alerts.school_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if (params['stage_id'] == '') {
      this.translate.get('alerts.stage_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if (params['grade_id'] == '') {
      this.translate.get('alerts.grade_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    // if(params['line_id'] == ''){
    //   this.translate.get('alerts.line_required').subscribe((res: string) =>{
    //     alert(res);
    //   })
    //   return false;
    // }
    if (params['num_list'] < 0) {
      this.translate.get('alerts.num_list_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }


    if (this.selectedFiles) {
      const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + params['num_list'] + '_original';
      const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
      uploadTask.snapshotChanges().pipe(
        finalize(() => {
          params['url'] = filePath.slice(0, -9)
          if (this.selectedSecondaryFiles) {
            const filePath2 = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + params['num_list'] + '_secondary' + '_original';
            const storageRef2 = this.firebaseStorageService.referenciaCloudStorage(filePath2);
            const uploadTask2 = this.firebaseStorageService.tareaCloudStorage(filePath2, this.selectedSecondaryFiles[0]);
            uploadTask2.snapshotChanges().pipe(
              finalize(() => {
                params['url2'] = filePath2.slice(0, -9)
                this.dataService.saveStudentphoto(params).subscribe(data => {
                  if (data == '') {
                    //this.router.navigateByUrl(`studentphotos`);
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.student_photo_saved'), duration: 4000, panelClass: "success-snackbar" })
                  }
                  else {
                    this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                    })
                  }
                })
              })
            ).subscribe();
          }
          else {
            params['url2'] = ''
            this.dataService.saveStudentphoto(params).subscribe(data => {
              if (data == '') {
                //this.router.navigateByUrl(`studentphotos`);
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.student_photo_saved'), duration: 4000, panelClass: "success-snackbar" })
              }
              else {
                this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                })
              }
            })
          }
        })
      ).subscribe();
    }
    else {
      this.route.params.subscribe(r => {
        if (r.id == 'new') {
          this.translate.get('alerts.photo_required').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
          return false;
        }
        else {
          params['url'] = '';
          if (this.selectedSecondaryFiles) {
            const filePath2 = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + params['num_list'] + '_secondary' + '_original';
            const storageRef2 = this.firebaseStorageService.referenciaCloudStorage(filePath2);
            const uploadTask2 = this.firebaseStorageService.tareaCloudStorage(filePath2, this.selectedSecondaryFiles[0]);
            uploadTask2.snapshotChanges().pipe(
              finalize(() => {
                params['url2'] = filePath2.slice(0, -9)
                this.dataService.saveStudentphoto(params).subscribe(data => {
                  if (data == '') {
                    //this.router.navigateByUrl(`studentphotos`);
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.student_photo_saved'), duration: 4000, panelClass: "success-snackbar" })
                  }
                  else {
                    this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                    })
                  }
                })
              })
            ).subscribe();
          }
          else {
            params['url2'] = ''
            this.dataService.saveStudentphoto(params).subscribe(data => {
              if (data == '') {
                //this.router.navigateByUrl(`studentphotos`);
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.student_photo_saved'), duration: 4000, panelClass: "success-snackbar" })
              }
              else {
                this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                })
              }
            })
          }




        }
      })

    }
  }

  // delete(id_student: string){
  //     var params={};

  //     params['id'] = id_student;


  //     

  //     this.dataService.deleteStudent(params).subscribe( data => {
  //       console.log(data)
  //       if (data == 'Student deleted'){
  //         alert(data);
  //         window.location.reload();
  //         // this.router.navigateByUrl(`item/` + params['item']);
  //       }
  //       else{
  //         alert(data);
  //       }
  //     })

  // }
  onPaginateChange(event: PageEvent) {
    this.dataSource = null;
    this.showStudentPhotosProgressBar = true;

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['role'] = ''
    params['school_id'] = this.filterForm.controls["schools"].value;
    params['stage_id'] = this.filterForm.controls["stages"].value;
    params['grade_id'] = this.filterForm.controls["grades"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;

    
    this.dataService.getStudentphotos(params).pipe(
      map((tableData: Student) => this.dataSource = tableData)
    ).subscribe(() => this.showStudentPhotosProgressBar = false)

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(schools => {
    //   this.schools = schools;
    //   this.dataSource.data = this.schools;

    //   // this.dataSource.filter = '';


    // });
  }

}
export class Student {
  constructor(
    public name: string,
    public last_name: string,
    public email: string,
    public id: string,
    public role: string
  ) { }
}


// export interface TableData{
//   items: Student[];
//   meta:{
//     totalSchools: number;
//     itemCount: number;
//     itemsPerPage: number;
//     totalPages: number;
//     currentPage: number;
//   },
//   links:{
//     first: string;
//     previous: string;
//     next: string;
//     last: string;
//   }
// }
